import { PrecisionType, TradeData } from "@shared/types";
import { PrecisionConfig } from "types";
import ChangeTag from "common/Tags/ChangeTag";
import React from "react";
import { TradeIdsToPnlMapping } from "@shared/services/socket/types";

interface PnlTagProps {
  tradeData: TradeData;
  amountChangeHeader: string;
  precisionConfig?: PrecisionConfig;
  socketPnlData?: TradeIdsToPnlMapping;
  /** Plain coloured value (new look tables). */
  hideBackground?: boolean;
}

const PnlTag = ({
  tradeData,
  amountChangeHeader,
  precisionConfig,
  socketPnlData,
  hideBackground,
}: PnlTagProps) => {
  const pnlData = socketPnlData?.[tradeData?.id];

  return (
    <ChangeTag
      value={(pnlData || tradeData)?.[amountChangeHeader]}
      showArrow={false}
      precisionType={PrecisionType.BALANCE}
      style={hideBackground ? NEW_LOOK_STYLE : CLASSIC_STYLE}
      precisionConfig={precisionConfig}
      hideBackground={hideBackground}
    />
  );
};

export default PnlTag;

const CLASSIC_STYLE = { marginLeft: 0 };
const NEW_LOOK_STYLE = {
  marginLeft: 0,
  fontWeight: 500,
  fontVariantNumeric: "tabular-nums",
} as const;
